import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  TextField,
  Popover,
  Paper,
  Dialog,
  DialogContent,
  DialogTitle,
  Chip,
  Grid,
  Autocomplete,
  CircularProgress,
  Menu,
  MenuItem,
} from "@mui/material";
import { useMediaQuery, useTheme } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { Collapse, Divider } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Search,
  Print,
  Download,
  Edit,
  Delete,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import { Close as CloseIcon } from "@mui/icons-material";
import {
  fetchpos,
  deletepos,
  ApprovePO,
  fetchSuppliers,
  GetApprovedPoReport,
} from "../../../Services/Services";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { Tooltip } from "@mui/material";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { handlePrint } from "../Purchase_order/PurchaseOrderPrint";
import InfiniteScroll from "react-infinite-scroll-component";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

pdfMake.vfs = pdfFonts.vfs;
const calculateValue = (item) => {
  let val = item.qty * item.price - item.discount;
  return (val + (val * item.tax) / 100).toFixed(2);
};

const PoReport = () => {
  const [po, setpos] = useState([]);
  const [projects, setProjects] = useState([]);
  const [openRow, setOpenRow] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [poToDelete, setPoToDelete] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [suppliers, setSuppliers] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [approveAnchorEl, setApproveAnchorEl] = useState(null);
  const [poToApprove, setPoToApprove] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [showRemarkForPoId, setShowRemarkForPoId] = useState(null);
  const [filters, setFilters] = useState({
    po_number: "",
    supplier: "",
    date_range: "today", // ✅ Add this
  });
  const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
  const [tempCustomDateRange, setTempCustomDateRange] = useState({
    from: "",
    to: "",
  });
  const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
  const [customDateRange, setCustomDateRange] = useState({
    from: "",
    to: "",
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedPO, setExpandedPO] = useState(null);

  const getDateRangeDisplay = (rangeType) => {
    const now = new Date();
    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    switch (rangeType) {
      case "today":
        return formatDate(now);
      case "yesterday":
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        return formatDate(yesterday);
      case "this_week":
        const weekStart = new Date(now);
        weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1);
        return `${formatDate(weekStart)} to ${formatDate(now)}`;
      case "previous_week":
        const prevWeekEnd = new Date(now);
        prevWeekEnd.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay());
        const prevWeekStart = new Date(prevWeekEnd);
        prevWeekStart.setDate(prevWeekStart.getDate() - 6);
        return `${formatDate(prevWeekStart)} to ${formatDate(prevWeekEnd)}`;
      case "this_month":
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        return `${formatDate(monthStart)} to ${formatDate(now)}`;
      case "current_year":
        const yearStart = new Date(now.getFullYear(), 0, 1);
        return `${formatDate(yearStart)} to ${formatDate(now)}`;
      case "financial_year":
        let fyStart;
        if (now.getMonth() >= 3) {
          fyStart = new Date(now.getFullYear(), 3, 1);
        } else {
          fyStart = new Date(now.getFullYear() - 1, 3, 1);
        }
        return `${formatDate(fyStart)} to ${formatDate(now)}`;
      default:
        return "";
    }
  };

  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  const handleReset = () => {
    setFilters({
      po_number: "", // ✅ Fix field names
      supplier: "", // ✅ Fix field names
      date_range: "today",
    });
    setCustomDateRange({ from: "", to: "" });
    setTempCustomDateRange({ from: "", to: "" }); // ✅ Add
    setShowCustomDateInputs(false); // ✅ Add
  };

  // ✅ Handle Custom Date Range Apply
  const handleApplyCustomDateRange = () => {
    if (tempCustomDateRange.from && tempCustomDateRange.to) {
      setCustomDateRange({
        from: tempCustomDateRange.from,
        to: tempCustomDateRange.to,
      });
      setFilters((prev) => ({ ...prev, date_range: "custom" }));
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    } else {
      toast.warning("Please select both From and To dates");
    }
  };

  // ✅ Handle Cancel Custom Date Range
  const handleCancelCustomDateRange = () => {
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
  };
useEffect(() => {
  const handler = setTimeout(() => {
    setPage(1);
    const updatedFilters = {
      ...filters,
      from_date: customDateRange.from || "",
      to_date: customDateRange.to || "",
    };
    loadPo(1, true, updatedFilters);
  }, 500); // ✅ Reduced debounce time
  
  return () => clearTimeout(handler);
}, [filters, customDateRange]);

  useEffect(() => {
    const loadSuppliers = async () => {
      try {
        const data = await fetchSuppliers();

        setSuppliers(Array.isArray(data) ? data : data.results || []);
      } catch (error) {
        console.error("Failed to load suppliers", error);
      }
    };

    loadSuppliers();
  }, []);

const loadPo = async (pageNum = 1, reset = false, filterValues = filters) => {
  try {
    // ✅ Use GetApprovedPOs instead of fetchpos
    const data = await GetApprovedPoReport(pageNum, filterValues);
    
    if (reset || pageNum === 1) {
      setProjects(data.results || []);
    } else {
      setProjects((prev) => [...prev, ...(data.results || [])]);
    }
    setHasMore(data.next !== null);
    setPage(pageNum);
  } catch (error) {
    console.error("Failed to load approved POs", error);
    toast.error("Failed to load approved POs");
  }
};


  const fetchMoreData = () => {
  const nextPage = page + 1;
  const updatedFilters = {
    ...filters,
    from_date: customDateRange.from || "",
    to_date: customDateRange.to || "",
  };
  loadPo(nextPage, false, updatedFilters);
};

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };
  const handleApprove = async (po) => {
    const approvedById = Number(localStorage.getItem("user_id"));
    if (!approvedById) {
      toast.error("Approver ID not found.");
      return;
    }
    try {
      const updated = await ApprovePO(
        po.po_id,
        approvedById,
        po.approval_status,
        remarkInput,
      ); // ✅ FIXED
      setpos((prev) =>
        prev.map((item) => (item.po_id === po.po_id ? updated : item)),
      );
      const UpdtedList = await fetchpos(filters);
      setProjects(UpdtedList.results);
      toast.success(
        updated.approval_status
          ? "PO approved successfully!"
          : "PO unapproved successfully!",
      );
    } catch (error) {
      console.error("Approval Error:", error);
      toast.error("Failed to approve PO.");
    }
  };
  // Decide which form to open based on your API shape
  const isPoWithoutIndent = (po) => {
    // Prefer explicit flags if available:
    if (typeof po.is_without_indent !== "undefined")
      return !!po.is_without_indent;
    if (typeof po.po_type !== "undefined")
      return String(po.po_type).toLowerCase().includes("without");

    // Fallback: if there's no indent, treat it as "without indent"
    return !po.indent && !po.indent_id;
  };

  const handleEdit = (po) => {
    const path = isPoWithoutIndent(po)
      ? "/dashboard/powithoutindent"
      : "/dashboard/po-form";

    navigate(path, { state: { poData: po, isEdit: true } });
  };

  const handleDeleteClick = (po) => {
    setPoToDelete(po);
    setDeleteDialogOpen(true);
  };

  const confirmDelete = async () => {
    try {
      await deletepos(poToDelete.po_id);
      setProjects((prev) => prev.filter((p) => p.po_id !== poToDelete.po_id));
      setPoToDelete(null);
      toast.success("Purchase order deleted successfully");
    } catch (error) {
      console.error("Delete failed", error);
      toast.error("Failed to delete purchase order");
    }
  };

  const handleClick = () => {
    navigate("/dashboard/po-form");
  };
  const handlePOwithoutIndent = () => {
    navigate("/dashboard/powithoutindent");
  };
  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  const userRole = localStorage.getItem("role");

  function formatOnlyDate(dateTimeString) {
    if (!dateTimeString) return "N/A";

    // Take only the date part (before T)
    const datePart = dateTimeString.split("T")[0]; // "2025-12-02"

    const [year, month, day] = datePart.split("-");

    return `${day}-${month}-${year}`;
  }

  useEffect(() => {
    document.body.style.overflow = isMobile ? "auto" : "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobile]);
  return (
    // <Box sx={{ backgroundColor: "#fff", p: 2 }}>
    <Box sx={{ px: 0, pt: 0, mt: -3, maxWidth: 1200, mx: "auto" }}>
      <Box
        sx={{
          mt: -3,
          pt: 0,
          mb: 1,
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Grid container spacing={1} alignItems="center">
          {/* Date Range Dropdown */}
          <Grid item xs={12} sm={2.5}>
            <TextField
              fullWidth
              label="Date Range"
              value={
                filters.date_range === "custom" &&
                customDateRange.from &&
                customDateRange.to
                  ? `${formatDateDisplay(customDateRange.from)} to ${formatDateDisplay(customDateRange.to)}`
                  : filters.date_range === "today"
                    ? "Today"
                    : filters.date_range === "yesterday"
                      ? "Yesterday"
                      : filters.date_range === "this_week"
                        ? "This Week"
                        : filters.date_range === "previous_week"
                          ? "Previous Week"
                          : filters.date_range === "this_month"
                            ? "This Month"
                            : filters.date_range === "current_year"
                              ? "Current Year"
                              : filters.date_range === "financial_year"
                                ? "Financial Year"
                                : "Select Date Range"
              }
              onClick={(e) => setDateMenuAnchor(e.currentTarget)}
              size="small"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <IconButton size="small" edge="end">
                    <ArrowDropDownIcon />
                  </IconButton>
                ),
              }}
              sx={{
                cursor: "pointer",
                "& .MuiInputBase-input": {
                  fontSize: "0.75rem",
                  padding: "4px 8px",
                },
                "& .MuiInputBase-root": {
                  height: 32,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
            />
          </Grid>

          {/* Search PO Number */}
          <Grid item xs={12} sm={2}>
            <TextField
              fullWidth
              label="Search PO Number"
              size="small"
              name="po_number"
              value={filters.po_number}
              onChange={handleFilterChange}
              sx={{
                "& .MuiInputBase-root": {
                  height: 32,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
            />
          </Grid>

          {/* Search Supplier */}
          <Grid item xs={12} sm={2}>
            <TextField
              fullWidth
              label="Search Supplier"
              size="small"
              name="supplier"
              value={filters.supplier}
              onChange={handleFilterChange}
              sx={{
                "& .MuiInputBase-root": {
                  height: 32,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
            />
          </Grid>

          {/* Reset Button */}
          <Grid item xs={4} sm={1.2}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              size="small"
              onClick={handleReset}
              sx={{
                height: 32,
                fontSize: { xs: "0.6rem", sm: "0.7rem" },
                borderRadius: 0,
                padding: "0 8px",
                minWidth: 0,
              }}
            >
              Reset
            </Button>
          </Grid>
        </Grid>

        {/* Date Range Menu - UPDATED */}
        <Menu
          anchorEl={dateMenuAnchor}
          open={Boolean(dateMenuAnchor)}
          onClose={() => {
            setDateMenuAnchor(null);
            setShowCustomDateInputs(false);
            setTempCustomDateRange({ from: "", to: "" });
          }}
          PaperProps={{
            sx: {
              width: 350,
              maxHeight: 500,
              "& .MuiTypography-root": {
                fontSize: "0.7rem",
              },
            },
          }}
        >
          {[
            { key: "today", label: "Today" },
            { key: "yesterday", label: "Yesterday" },
            { key: "this_week", label: "This Week" },
            { key: "previous_week", label: "Previous Week" },
            { key: "this_month", label: "This Month" },
            { key: "current_year", label: "Current Year" },
            { key: "financial_year", label: "Financial Year" },
          ].map((range) => (
            <MenuItem
              key={range.key}
              onClick={() => {
                setFilters((prev) => ({ ...prev, date_range: range.key }));
                setCustomDateRange({ from: "", to: "" });
                setDateMenuAnchor(null);
                setShowCustomDateInputs(false);
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography variant="body2">{range.label}</Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: "0.65rem" }}
                >
                  {getDateRangeDisplay(range.key)}
                </Typography>
              </Box>
            </MenuItem>
          ))}

          <Divider />

          {/* ✅ Custom Date Range - Expandable */}
          <MenuItem
            onClick={() => setShowCustomDateInputs(!showCustomDateInputs)}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              bgcolor: showCustomDateInputs ? "#e3f2fd" : "inherit",
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: showCustomDateInputs ? 600 : 400 }}
            >
              Custom Date Range
            </Typography>
            {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
          </MenuItem>

          {/* ✅ Both Date Pickers Together */}
          <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
            <Box
              sx={{
                px: 2,
                py: 2,
                bgcolor: "#f5f5f5",
                borderTop: "1px solid #e0e0e0",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ mb: 1, display: "block" }}
              >
                Select Date Range
              </Typography>

              {/* From and To Date Inputs Side by Side */}
              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                  label="From Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.from}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      from: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    max:
                      tempCustomDateRange.to ||
                      new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />

                <TextField
                  label="To Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.to}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      to: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    min: tempCustomDateRange.from || undefined,
                    max: new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />
              </Box>

              {/* Selected Range Preview */}
              {tempCustomDateRange.from && tempCustomDateRange.to && (
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    mb: 1.5,
                    p: 1,
                    bgcolor: "#e8f5e9",
                    borderRadius: 1,
                    textAlign: "center",
                    color: "#2e7d32",
                    fontWeight: 500,
                  }}
                >
                  📅 {formatDateDisplay(tempCustomDateRange.from)} to{" "}
                  {formatDateDisplay(tempCustomDateRange.to)}
                </Typography>
              )}

              {/* Apply and Cancel Buttons */}
              <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCancelCustomDateRange}
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleApplyCustomDateRange}
                  disabled={
                    !tempCustomDateRange.from || !tempCustomDateRange.to
                  }
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Apply
                </Button>
              </Box>
            </Box>
          </Collapse>
        </Menu>
      </Box>

      <InfiniteScroll
        dataLength={projects.length}
        next={fetchMoreData}
        hasMore={hasMore}
        // height={"75vh"}
        loader={<h4>Loading...</h4>}
        endMessage={<p style={{ textAlign: "center" }}>No more pos!</p>}
      >
        {isMobile ? (
          <Box sx={{ bgcolor: "background.paper" }}>
            {projects.map((po, index) => (
              <Box key={po.id}>
                <Box
                  onClick={() =>
                    setExpandedPO(expandedPO === po.id ? null : po.id)
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                    cursor: "pointer",
                    bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                    "&:active": {
                      bgcolor: "#e3f2fd",
                    },
                    borderLeft: `4px solid ${
                      po.approval_status === "Approved"
                        ? "#4caf50"
                        : po.approval_status === "Reject"
                          ? "#f44336"
                          : "#ff9800"
                    }`,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 0.5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#666",
                          minWidth: 25,
                        }}
                      >
                        #{index + 1}
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.85rem",
                          flex: 1,
                        }}
                      >
                        {po.po_number}
                      </Typography>
                      
                    </Box>

                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        color: "#666",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <span style={{ fontWeight: 500 }}>
                        {suppliers
                          .find((s) => s.id === po.supplier)
                          ?.name?.substring(0, 20) || `Supplier ${po.supplier}`}
                      </span>
                      <span style={{ color: "#999" }}>•</span>
                      <span style={{ fontSize: "0.7rem" }}>
                        {formatOnlyDate(po.created_at)}
                      </span>
                    </Typography>
                  </Box>

                  <IconButton size="small" sx={{ ml: 1 }}>
                    {expandedPO === po.id ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </IconButton>
                </Box>

                <Collapse
                  in={expandedPO === po.id}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      px: 1.5,
                      py: 1,
                      bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
                      borderLeft: `4px solid ${
                        po.approval_status === "Approved"
                          ? "#4caf50"
                          : po.approval_status === "Reject"
                            ? "#f44336"
                            : "#ff9800"
                      }`,
                    }}
                  >
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 0.8,
                        mb: 1,
                      }}
                    >
                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          SUPPLIER
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            color: "#333",
                          }}
                        >
                          {suppliers.find((s) => s.id === po.supplier)?.name ||
                            `Supplier ${po.supplier}`}
                        </Typography>
                      </Box>

                      {po.created_by_name && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            CREATED BY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {po.created_by_name}
                          </Typography>
                        </Box>
                      )}

                      {po.approved_name && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            APPROVED BY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {po.approved_name}
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    <Box sx={{ mb: 0.8 }}>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#999",
                          letterSpacing: "0.5px",
                          mb: 0.3,
                        }}
                      >
                        BILLING ADDRESS
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#555",
                          lineHeight: 1.3,
                        }}
                      >
                        {po.billing_address}
                      </Typography>
                    </Box>

                    <Box sx={{ mb: 0.8 }}>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#999",
                          letterSpacing: "0.5px",
                          mb: 0.3,
                        }}
                      >
                        SHIPPING ADDRESS
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#555",
                          lineHeight: 1.3,
                        }}
                      >
                        {po.shipping_address}
                      </Typography>
                    </Box>

                    {po.remarks && (
                      <Box sx={{ mb: 0.8 }}>
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                            mb: 0.3,
                          }}
                        >
                          REMARKS
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#555",
                            fontStyle: "italic",
                            lineHeight: 1.3,
                          }}
                        >
                          {po.remarks}
                        </Typography>
                      </Box>
                    )}

                    <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      {userRole != "Staff" && (
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            setApproveAnchorEl(e.currentTarget);
                            setPoToApprove(po);
                          }}
                          sx={{
                            bgcolor:
                              po.approval_status === "Approved"
                                ? "#e8f5e9"
                                : po.approval_status === "Reject"
                                  ? "#ffebee"
                                  : "#fff3e0",
                            borderRadius: "8px",
                            width: 36,
                            height: 36,
                            border: `1px solid ${
                              po.approval_status === "Approved"
                                ? "#4caf50"
                                : po.approval_status === "Reject"
                                  ? "#f44336"
                                  : "#ff9800"
                            }`,
                            "&:hover": {
                              transform: "scale(1.05)",
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <VisibilityIcon
                            sx={{
                              fontSize: "1.1rem",
                              color:
                                po.approval_status === "Approved"
                                  ? "#2e7d32"
                                  : po.approval_status === "Reject"
                                    ? "#c62828"
                                    : "#f57c00",
                            }}
                          />
                        </IconButton>
                      )}

                      {/* Replace the entire action buttons Box in mobile view */}
                      <Box
                        sx={{
                          display: "flex",
                          gap: 0.6,
                          justifyContent: "flex-end",
                        }}
                      >
                        {/* ✅ Only keep Print button */}
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handlePrint(po);
                          }}
                          sx={{
                            bgcolor: "#f3e5f5",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#e1bee7",
                              transform: "scale(1.05)",
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Print sx={{ fontSize: "1rem", color: "#7b1fa2" }} />
                        </IconButton>
                      </Box>
                    </Box>
                  </Box>
                </Collapse>

                <Divider />
              </Box>
            ))}
          </Box>
        ) : (
          /* 💻 DESKTOP TABLE VIEW */
          <TableContainer
            component={Paper}
            sx={{ maxHeight: "88vh", overflow: "auto" }}
          >
            <Table
              stickyHeader
              size="small"
              sx={{
                minWidth: "max-content",
                "& td, & th": {
                  borderBottom: "1px solid #ccc",
                  whiteSpace: "nowrap",
                },
              }}
            >
              <TableHead
                sx={{
                  "& th": {
                    fontWeight: "bold",
                    fontSize: "0.8rem !important",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#2196f3" : "#333",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                  },
                }}
              >
                <TableRow
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "& th": {
                      fontWeight: "bold",
                      color: "#333",
                      borderBottom: "1px solid #999",
                      whiteSpace: "nowrap",
                    },
                  }}
                >
                  {userRole != "Staff" && (
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 7,
                        minWidth: 80,
                      }}
                      align="center"
                    >
                      View
                    </TableCell>
                  )}

                  <TableCell
                    sx={{
                      position: "sticky",
                      left: userRole != "Staff" ? 80 : 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                      minWidth: 80,
                    }}
                    align="center"
                  >
                    S.No.
                  </TableCell>
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: userRole != "Staff" ? 160 : 80,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                      minWidth: 120,
                    }}
                    align="center"
                  >
                    PO Number
                  </TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Supplier</TableCell>
                  <TableCell align="center">Billing Address</TableCell>
                  <TableCell align="center">Shipping Address</TableCell>
                  <TableCell align="center">Created At</TableCell>
                  <TableCell align="center">Created By</TableCell>
                  <TableCell align="center">Approved By</TableCell>
                  <TableCell align="center">Remarks</TableCell>
                  <TableCell
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#fff",
                      zIndex: 3,
                    }}
                    align="center"
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {projects.map((po, index) => (
                  <React.Fragment key={po.id}>
                    <TableRow
                      hover
                      sx={{
                        backgroundColor:
                          index % 2 === 0 ? "#fafafa" : "#ffffff",
                        "&:hover": {
                          backgroundColor: "#e3f2fd",
                          "& td": {
                            backgroundColor: "#e3f2fd !important",
                          },
                        },
                        "& td": {
                          paddingRight: "13px !important",
                          paddingLeft: "13px !important",
                          padding: "0px",
                          fontSize: { xs: "0.8rem !important", sm: "0.75rem" },
                          whiteSpace: "nowrap",
                          color: (theme) =>
                            theme.palette.mode === "dark" ? "white" : "inherit",
                          backgroundColor: (theme) =>
                            theme.palette.mode === "dark" ? "black" : "inherit",
                        },
                      }}
                    >
                      {userRole != "Staff" && (
                        <TableCell
                          sx={{
                            position: "sticky",
                            left: 0,
                            backgroundColor: "#fafafa",
                            zIndex: 2,
                            minWidth: 80,
                          }}
                          align="center"
                        >
                          {/* ✅ Changed from Checkbox to IconButton with Eye Icon */}
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              setApproveAnchorEl(e.currentTarget);
                              setPoToApprove(po);
                            }}
                            sx={{
                              padding: 0,
                              color:
                                po.approval_status === "Approved"
                                  ? "green"
                                  : po.approval_status === "Reject"
                                    ? "red"
                                    : "grey",
                            }}
                          >
                            <VisibilityIcon sx={{ transform: "scale(0.7)" }} />
                          </IconButton>
                        </TableCell>
                      )}

                      <TableCell
                        sx={{
                          position: "sticky",
                          left: userRole != "Staff" ? 80 : 0,
                          backgroundColor: "#fafafa",
                          zIndex: 2,
                          minWidth: 80,
                        }}
                        align="center"
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell
                        sx={{
                          position: "sticky",
                          left: userRole != "Staff" ? 160 : 80,
                          backgroundColor: "#fafafa",
                          zIndex: 2,
                          minWidth: 120,
                        }}
                        align="center"
                      >
                        {po.po_number}
                      </TableCell>
                      <TableCell align="center">
                        <Chip
                          label={
                            po.approval_status === "Approved"
                              ? "Approved"
                              : po.approval_status === "Reject"
                                ? "Reject"
                                : "Pending"
                          }
                          color={
                            po.approval_status === "Approved"
                              ? "success"
                              : po.approval_status === "Reject"
                                ? "error"
                                : "warning"
                          }
                          variant="outlined"
                          size="small"
                          sx={{
                            // fontSize: "0.2rem", // 👈 font chhota hoga
                            height: "10px",
                            transform: "scale(0.8)",
                            "& .MuiChip-label": {
                              padding: "0 6px",
                            },
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        {suppliers.find((s) => s.id === po.supplier)?.name ||
                          `Supplier ${po.supplier}`}
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title={po.billing_address} arrow>
                          <span>{truncateText(po.billing_address, 20)}</span>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="center">
                        {po.shipping_address}
                      </TableCell>
                      <TableCell>{formatOnlyDate(po.created_at)}</TableCell>
                      <TableCell align="center">
                        {po.created_by_name ? po.created_by_name : "N/A"}
                      </TableCell>
                      <TableCell align="center">
                        {po.approved_name ? po.approved_name : ""}
                      </TableCell>
                      <TableCell align="center">{po.remarks || ""}</TableCell>
                      <TableCell
                        sx={{
                          position: "sticky",
                          right: 0,
                          zIndex: 3,
                        }}
                        align="center"
                      >
                        {/* ✅ Only keep Print button */}
                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          size="small"
                          color="primary"
                          onClick={() => handlePrint(po)}
                        >
                          <Print transform="scale(0.6)" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </InfiniteScroll>

      <ToastContainer position="top-right" autoClose={3000} />

      <Dialog
        open={Boolean(approveAnchorEl)}
        onClose={() => {
          setApproveAnchorEl(null);
          setPoToApprove(null);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: "85vh",
            width: { xs: "95%", md: "80%", lg: 900 },
          },
        }}
      >
             {/* ✅ Header with Close Button */}
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 0.5,
          px: 1.5,
          mb: 1,
          borderBottom: "1px solid #e0e0e0",
          bgcolor: "#f5f5f5",
        }}
      >
        <Typography variant="subtitle1" fontWeight="bold">
          PO Details - {poToApprove?.po_number}
        </Typography>
        <IconButton
          size="small"
          onClick={() => {
            setApproveAnchorEl(null);
            setPoToApprove(null);
          }}
          sx={{
            color: "#666",
            "&:hover": {
              color: "#d32f2f",
              bgcolor: "#ffebee",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* ✅ Scrollable Content - EXACT PDF REPLICA */}
      <DialogContent sx={{ p: 3, bgcolor: "#fff" }}>
        
        {/* Main Heading */}
        <Box sx={{ textAlign: "center", mb: 2 }}>
          <Typography variant="h6" fontWeight="bold" sx={{ textDecoration: "underline" }}>
            PURCHASE ORDER
          </Typography>
        </Box>

        {/* ================= HEADER BOX (Recipient, PO Info, Supplier) ================= */}
        <Box sx={{ border: "1px solid #000" }}>
          
          {/* --- ROW 1: Recipient (Left) | PO Details (Right) --- */}
          <Box sx={{ display: "flex", borderBottom: "1px solid #000" }}>
            
            {/* LEFT: Details of Recipient */}
            <Box sx={{ width: "50%", p: 1, borderRight: "1px solid #000" }}>
              <Typography variant="subtitle2" fontWeight="bold" sx={{ textDecoration: "underline", mb: 0.5 }}>
                Details of Recipient (Billed to)
              </Typography>
              
               <Box sx={{ display: "flex" }}>
                <Typography variant="caption" fontWeight="bold" sx={{ minWidth: 60 }}>Name</Typography>
                <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                <Typography variant="caption">
                  {poToApprove?.billed_to_name
 || "KP And Grandsons Pvt. Ltd."}
                </Typography>
              </Box>

              <Box sx={{ display: "flex" }}>
                <Typography variant="caption" fontWeight="bold" sx={{ minWidth: 60 }}>Address</Typography>
                <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                <Typography variant="caption" sx={{ whiteSpace: "pre-wrap" }}>
                  {poToApprove?.billed_to_address || "Plot No. 37 Phase II, Siltara Industrial Area, Raipur(C.G.)-493111 India"}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.5 }}>
                <Box sx={{ display: "flex" }}>
                  <Typography variant="caption" fontWeight="bold">State Name</Typography>
                  <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                  <Typography variant="caption">
                    {poToApprove?.billed_to_state_name || "Chhattisgarh"}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex" }}>
                   <Typography variant="caption" fontWeight="bold">State Code</Typography>
                   <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                   <Typography variant="caption">
                     {poToApprove?.billed_to_state_code || "22"}
                   </Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex" }}>
                <Typography variant="caption" fontWeight="bold" sx={{ minWidth: 60 }}>GSTIN</Typography>
                <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                <Typography variant="caption">{poToApprove?.billed_to_gst_no || "22AAHFK2314C1Z4"}</Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography variant="caption" fontWeight="bold" sx={{ minWidth: 60 }}>PAN No.</Typography>
                <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                <Typography variant="caption">{poToApprove?.billed_to_pan_no || "AAHFK2314C"}</Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography variant="caption" fontWeight="bold" sx={{ minWidth: 60 }}>Contact</Typography>
                <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                <Typography variant="caption">{poToApprove?.billed_to_contact || "+91 9302125991"}</Typography>
              </Box>
            </Box>

            {/* RIGHT: PO Number, Date, Division, Indent */}
            <Box sx={{ width: "50%", p: 1 }}>
               <Box sx={{ display: "flex", mb: 0.5 }}>
                  <Typography variant="caption" fontWeight="bold" sx={{ minWidth: 80 }}>PO Number</Typography>
                  <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                  <Typography variant="caption">{poToApprove?.po_number || "KP&G/PO/26-27/41"}</Typography>
               </Box>
               <Box sx={{ display: "flex", mb: 0.5 }}>
                  <Typography variant="caption" fontWeight="bold" sx={{ minWidth: 80 }}>Date</Typography>
                  <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                  <Typography variant="caption">{formatOnlyDate(poToApprove?.created_at)}</Typography>
               </Box>
               <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Typography variant="caption" fontWeight="bold" sx={{ minWidth: 80 }}>Division</Typography>
                  <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                  <Typography variant="caption">{poToApprove?.division_name || "Div-04"}</Typography>
               </Box>

               <Box sx={{ borderTop: "1px solid #ccc", pt: 1 }}>
                 <Box sx={{ display: "flex", mb: 0.5 }}>
                    <Typography variant="caption" fontWeight="bold">PARTY REF. NO.</Typography>
                    <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                    <Typography variant="caption">{poToApprove?.party_ref_no || "No Reference"}</Typography>
                 </Box>
                 <Box sx={{ display: "flex" }}>
                    <Typography variant="caption" fontWeight="bold">INDENT NO.</Typography>
                    <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                    <Typography variant="caption">{poToApprove?.indent_no || "JAN-26-Div-01-8"}</Typography>
                 </Box>
               </Box>
            </Box>
          </Box>


<Box sx={{ p: 1 }}>
              <Typography variant="subtitle2" fontWeight="bold" sx={{ textDecoration: "underline", mb: 0.5 }}>
                Details of Supplier (Billed from)
              </Typography>
              
              {/* Organized using Grid for layout, but visually one single block */}
              <Grid container>
                {/* Left Side: Name, Address, State */}
                <Grid item xs={12} sm={6}>
                  <Box sx={{ display: "flex" }}>
                    <Typography variant="caption" fontWeight="bold" sx={{ minWidth: 70 }}>Name</Typography>
                    <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                    <Typography variant="caption">
                      {poToApprove?.billing_name || "JAN-26-Div-01-8"}
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex" }}>
                    <Typography variant="caption" fontWeight="bold" sx={{ minWidth: 70 }}>Address</Typography>
                    <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                    <Typography variant="caption" sx={{ whiteSpace: "pre-wrap" }}>
                      {poToApprove?.billing_address || "---"}
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex" }}>
                    <Typography variant="caption" fontWeight="bold" sx={{ minWidth: 70 }}>State Name</Typography>
                    <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                    <Typography variant="caption">{poToApprove?.supplier_state_name || "Not Defined"}</Typography>
                  </Box>

                  <Box sx={{ display: "flex" }}>
                    <Typography variant="caption" fontWeight="bold" sx={{ minWidth: 70 }}>State Code</Typography>
                    <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                    <Typography variant="caption">{poToApprove?.supplier_state_code || "Not Defined"}</Typography>
                  </Box>
                </Grid>

                {/* Right Side: GSTIN, PAN, Contact */}
                <Grid item xs={12} sm={6}>
                  <Box sx={{ display: "flex" }}>
                      <Typography variant="caption" fontWeight="bold" sx={{ minWidth: 70 }}>GSTIN</Typography>
                      <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                      <Typography variant="caption">{poToApprove?.billing_gst || "27ABCDE1234F1Z5"}</Typography>
                  </Box>
                  <Box sx={{ display: "flex" }}>
                      <Typography variant="caption" fontWeight="bold" sx={{ minWidth: 70 }}>PAN No.</Typography>
                      <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                      <Typography variant="caption">{poToApprove?.billing_pan || "ABCDE1234F"}</Typography>
                  </Box>
                  <Box sx={{ display: "flex" }}>
                      <Typography variant="caption" fontWeight="bold" sx={{ minWidth: 70 }}>Contact</Typography>
                      <Typography variant="caption" sx={{ mx: 0.5 }}>:</Typography>
                      <Typography variant="caption">{poToApprove?.billing_contact || "8745896663"}</Typography>
                  </Box>
                </Grid>
              </Grid>
          </Box>
        </Box>

        {/* ================= ITEMS TABLE ================= */}
        <TableContainer sx={{ border: "1px solid #000", borderBottom: "none" }}>
          <Table size="small" sx={{ 
              "& .MuiTableCell-root": { 
                borderRight: "1px solid #000", 
                borderBottom: "1px solid #000",
                padding: "4px 8px",
                fontSize: "0.75rem"
              },
              "& .MuiTableCell-root:last-child": { borderRight: "none" }
            }}>
            <TableHead>
              <TableRow sx={{ bgcolor: "#fff" }}>
                <TableCell align="center" sx={{ fontWeight: "bold", width: 40 }}>S NO.</TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>ITEM</TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>SIZE</TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>UNIT</TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>DESCRIPTION</TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>PO QTY</TableCell>
                     <TableCell align="center" sx={{ fontWeight: "bold" }} style={{ backgroundColor: "yellow" }}>REC QTY</TableCell>
                {/* <TableCell align="center" sx={{ fontWeight: "bold" }}>UNIT PRICE</TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>AMOUNT</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {poToApprove?.items?.length > 0 ? poToApprove.items.map((item, idx) => {
                 const amount = (parseFloat(item.quantity || 0) * parseFloat(item.rate || 0));
                 return (
                  <TableRow key={idx}>
                    <TableCell align="center">{idx + 1}</TableCell>
                    <TableCell align="center">{item.item_name || "Jitendra"}</TableCell>
                    <TableCell align="center">{item.size || "10"}</TableCell>
                    <TableCell align="center">{item.unit || item.uom || "mm"}</TableCell>
                    <TableCell align="left">{item.description || item.item_description || "Payment Terms"}</TableCell>
                     <TableCell align="center">{item.main_quantity || "97"}</TableCell>
                    <TableCell align="center"  style={{ backgroundColor: "yellow" }}>{Number(item.main_quantity || 0) - Number(item.quantity || 0) }</TableCell>
                   
{/*                    
                    <TableCell align="center">{item.rate || "520"}</TableCell>
                    <TableCell align="right">{amount ? amount.toFixed(2) : "50440.00"}</TableCell> */}
                  </TableRow>
                );
              }) : (
                // Dummy row if no items found, to match image style
                <TableRow>
              
                </TableRow>
              )}
              
              {/* TOTAL ROW */}
              {/* <TableRow>
                <TableCell colSpan={8} align="right" sx={{ fontWeight: "bold", borderBottom: "1px solid #000" }}>TOTAL</TableCell>
                <TableCell align="right" sx={{ fontWeight: "bold", borderBottom: "1px solid #000" }}>
                  {poToApprove?.items?.length > 0 ? 
                    poToApprove.items.reduce((acc, item) => acc + (parseFloat(item.quantity || 0) * parseFloat(item.rate || 0)), 0).toFixed(2) 
                    : "50440.00"}
                </TableCell>
              </TableRow> */}
            </TableBody>
          </Table>
        </TableContainer>

      </DialogContent>
      </Dialog>
      {/* Delete popover */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setPoToDelete(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, maxWidth: 200 }}>
          <Typography variant="body2" gutterBottom>
            Are you sure you want to delete <strong>{poToDelete?.name}</strong>?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl(null);
                setPoToDelete(null);
              }}
            >
              Close
            </Button>
            <Button
              size="small"
              color="error"
              onClick={async () => {
                await confirmDelete(poToDelete);
                setAnchorEl(null);
                setPoToDelete(null);
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};

export default PoReport;
